import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { Box, BoxItem, BoxListResponse, Project, Zone } from 'models/setup/mobile/BoxLocation';
import { callApi } from 'utils/ApiUtil';

/**
 * 프로젝트 목록 조회
 */
export const getProjects = async () => {
  const request: CommonRequest = {
    method: Method.GET,
    url: '/v1/mobilesetup/project',
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<Project[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as Project[];
};

/**
 * 프로젝트별 박스 목록 조회
 */
export const getBoxesByProject = async (
  elmPrjId: string,
  boxStatus = 'ARRIVAL_DONE',
  bmkStatus?: string
) => {
  let url = `/v1/mobilesetup/project/${elmPrjId}/boxs?boxStatus=${boxStatus}`;
  if (bmkStatus) {
    url += `&bmkStatus=${bmkStatus}`;
  }
  const request: CommonRequest = {
    method: Method.GET,
    url,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<BoxListResponse> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data?.boxs : null) as Box[];
};

/**
 * 박스 상세 정보 조회 (품목 포함)
 */
export const getBoxDetail = async (boxId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mobilesetup/box/${boxId}`,
    serviceName: ServiceName.ELM_BE,
  };

  const response: CommonResponse<Box & { items: BoxItem[] }> = await callApi(request);

  return response.successOrNot === 'Y' ? response.data : null;
};

/**
 * 프로젝트별 구역 목록(대표구역, 하역장) 조회
 */
export const getZonesByProject = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mobilesetup/map/zonesbyproject/${elmPrjId}`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<Zone[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as Zone[];
};

/**
 * 프로젝트별 품목 목록 조회
 */
export interface GetItemsByProjectParams {
  projectId: string;
  itemStatus?: string;
  bcdStatus?: string;
  page?: number;
  keyword?: string;
  langCd?: string;
}

export const getItemsByProject = async (params: GetItemsByProjectParams) => {
  const { projectId, itemStatus, bcdStatus, page = 1, keyword, langCd = 'ko' } = params;

  const queryParams = new URLSearchParams();
  if (itemStatus) queryParams.append('itemStatus', itemStatus);
  if (bcdStatus) queryParams.append('bcdStatus', bcdStatus);
  if (page) queryParams.append('page', String(page));
  if (keyword) queryParams.append('keyword', keyword);
  if (langCd) queryParams.append('langCd', langCd);

  const queryString = queryParams.toString();
  const url = `/v1/mobilesetup/project/${projectId}/items${queryString ? `?${queryString}` : ''}`;

  const request: CommonRequest = {
    method: Method.GET,
    url,
    serviceName: ServiceName.ELM_BE,
  };

  const response: CommonResponse<{
    items: BoxItem[];
    totalCount: number;
    page: number;
    size: number;
  }> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data?.items : null) as BoxItem[];
};

/**
 * 구역 일괄 삭제
 */
export const deleteZones = async (zoneIds: string[]) => {
  const request: CommonRequest = {
    method: Method.DELETE,
    url: `/v1/mobilesetup/map/zones?mapZonIds=${zoneIds.join(',')}`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<Record<string, unknown>> = await callApi(request);
  return response;
};

/**
 * 좌표 일괄 삭제
 */
export const deleteCoordinates = async (coordinateIds: string[]) => {
  const request: CommonRequest = {
    method: Method.DELETE,
    url: `/v1/mobilesetup/map/zones/coordinates?mapZonCrdIds=${coordinateIds.join(',')}`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<Record<string, unknown>> = await callApi(request);
  return response;
};
